import React from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import Geocode from "react-geocode";

const containerStyle = {
  width: "100%",
  height: "30vh",
};

function GmapsComponent(props) {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.GOOGLE_MAPS_API_KEY,
  });

  const center = props.position;

  const [map, setMap] = React.useState(null);
  const OPTIONS = {
    minZoom: 5,
    maxZoom: 19,
  };

  const onLoad = React.useCallback(function callback(map) {
    const bounds = new window.google.maps.LatLngBounds(center);
    map.fitBounds(bounds);
    setMap(map);
  }, []);

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  const iamMoved = React.useCallback(function callback(map) {
    Geocode.setApiKey(process.env.GOOGLE_MAPS_API_KEY);
    Geocode.setLanguage("en");
    const coordinates = this.getPosition().toJSON();
    props.onPositionChanged(coordinates);
    Geocode.fromLatLng(coordinates.lat, coordinates.lng).then(
      (response) => {
        const address = response.results[0].formatted_address;
        console.log(address);
      },
      (error) => {
        console.error(error);
      },
    );
  }, []);

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={containerStyle}
      options={OPTIONS}
      center={center}
      zoom={props.zoom}
      onLoad={onLoad}
      onUnmount={onUnmount}>
      <Marker
        position={center}
        draggable={props.draggableMarker}
        onDragEnd={iamMoved}
      />
    </GoogleMap>
  ) : (
    <></>
  );
}

export default React.memo(GmapsComponent);
